import * as config from '../config';
export const registerUserService = (request) => {
  const REGISTER_API_ENDPOINT = 'http://localhost:3000/api/v2/register';
  
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.user)
  };

  return fetch(REGISTER_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json)
      return json;
    });
};

export const loginUserService = (request) => {
  const LOGIN_API_ENDPOINT = config.URL_WEBSERVICE+'/api/auth/login';

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request.user)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => {
      localStorage.setItem('username',request.user.username);
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const getDSDangChoService = (request) => {
  const LOGIN_API_ENDPOINT = config.URL_WEBSERVICE+"/api/data/dsdangcho";
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request.data)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => { 
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const getDSHoanTatService = (request) => {
 
  const LOGIN_API_ENDPOINT = config.URL_WEBSERVICE+"/api/data/dshoantat";
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request.data)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => {
     
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const getChiTietCLSService = (request) => { 
  const LOGIN_API_ENDPOINT = config.URL_WEBSERVICE+"/api/data/chitietcls";

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request.data)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => {
     
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const saveDataCLSService = (request) => {
  const LOGIN_API_ENDPOINT = config.URL_WEBSERVICE+"/api/savedata/cls";

  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request.data)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
    .then(response => { 
      return response.json();
    })
    .then(json => {
      return json;
    });
};